import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { PyramidType } from '../../../types'
import { PyramidsColumnGraphData, PyramidsData } from '../../pyramids/pyramidUtils'
import { PyramidsColumnGraph } from '../../pyramids/visualization/PyramidsColumnGraph'
import './company-settings-pyramids-graph.less'

type Props = {
  data: PyramidsData[]
  type: PyramidType
}

const mapCompanySettingsDataToColumnGraph = (data: PyramidsData[]): PyramidsColumnGraphData[] =>
  data
    .filter(({ name }) => name !== 'total')
    .map(({ name, recommendedRange }) => ({
      name,
      recommendedRange,
    }))

export const CompanySettingsPyramidsGraph: FC<Props> = ({ data, type }) => {
  const { t } = useTranslation()

  return (
    <PyramidsColumnGraph
      data={mapCompanySettingsDataToColumnGraph(data)}
      type={type}
      variant="companySettings"
      chartAriaLabel={t('companySettingsView.pyramidsTab.row.chartAria')}
      showCurrent={false}
    />
  )
}
